
/* injects from baggage-loader */

// Formas Amarelas
import y_circle from '_images/red/shapes/yellow-circle.png';
import y_rectangle from '_images/red/shapes/yellow-rectangle.png';
import y_square from '_images/red/shapes/yellow-square.png';
import y_triangle from '_images/red/shapes/yellow-triangle.png';

// Formas Vermelhas
import r_circle from '_images/red/shapes/red-circle.png';
import r_rectangle from '_images/red/shapes/red-rectangle.png';
import r_square from '_images/red/shapes/red-square.png';
import r_triangle from '_images/red/shapes/red-triangle.png';

// Formas Azuis
import b_circle from '_images/red/shapes/blue-circle.png';
import b_rectangle from '_images/red/shapes/blue-rectangle.png';
import b_square from '_images/red/shapes/blue-square.png';
import b_triangle from '_images/red/shapes/blue-triangle.png';

export const shapes = [
	{src: y_circle, alt: "Círculo amarelo"},  
	{src: y_triangle, alt: "Triângulo amarelo"}, 
	{src: y_square, alt: "Quadrado amarelo"}, 
	{src: y_rectangle, alt: "Retângulo amarelo"},
	{src: r_circle, alt: "Círculo vermelho"},  
	{src: r_triangle, alt: "Triângulo vermelho"}, 
	{src: r_square, alt: "Quadrado vermelho"},
	{src: r_rectangle, alt: "Retângulo vermelho"},
	{src: b_circle, alt: "Círculo azul"},
	{src: b_triangle, alt: "Triângulo azul"},
	{src: b_square, alt: "Quadrado azul"},
	{src: b_rectangle, alt: "Retângulo azul"}
]


// WEBPACK FOOTER //
// ./src/app/components/ui/logic-game/logic-game.const.js